import { Range } from 'slate';
import getRangeRect from './getRangeRect';
export default function getBlockRect(editor, block) {
  var blockRange = Range.create().moveToRangeOfNode(block).normalize(editor.value.document);
  return getRangeRect(editor, blockRange);
}